export default __webpack_public_path__ + "static/media/coming_soon.03e37901.png";